import * as Bixby from '$/core';
import { GLOBAL_SEARCH_INPROGRESS, GLOBAL_SEARCH_SUCCESS, GLOBAL_SEARCH_FAILURE, SearchTypes } from './types';
import { SearchResult } from '$/core/models';
import { ThunkAction } from 'redux-thunk';
import { AppState } from '$/store';
import { CompanyService } from '$/services';

const globalSearchInProgress = () => {
  return { type: GLOBAL_SEARCH_INPROGRESS };
};
const globalSearchSuccess = (payload?: SearchResult[]) => {
  return { type: GLOBAL_SEARCH_SUCCESS, payload };
};
const globalSearchFailure = (error: Bixby.Models.BixbyError) => {
  return { type: GLOBAL_SEARCH_FAILURE, payload: error };
};

export const doSearchAction =
  (
    searchText: string,
    searchIn: SearchTypes,
    linkToAdmin?: boolean
  ): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(globalSearchInProgress());
    if (Bixby.Utils.isNullOrEmpty(searchText)) {
      dispatch(globalSearchSuccess(undefined));
    } else {
      switch (searchIn) {
        case 'company':
          const companies: Bixby.Models.EntitySearchResult[] = await CompanyService.searchCompany(searchText);
          if (companies) {
            const mapped = companies.map(_ => {
              const route = `/${searchIn}/${_.id}`;
              const link = linkToAdmin ? `/admin${route}` : route;
              return { category: Bixby.Constants.SEARCH_CATEGORY_COMPANY, result: _.name, link } as SearchResult;
            });
            dispatch(globalSearchSuccess(mapped));
          } else {
            const error: Bixby.Models.BixbyError = {
              name: 'GlobalSearchFailure',
              message: 'Nothing in the `companies` state object',
            };
            dispatch(globalSearchFailure(error));
          }
      }
    }
  };

export const clearSearchAction =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    await dispatch(globalSearchSuccess(undefined));
  };
